import type { Tagged } from "type-fest";

export type AgentActivity = Tagged<string, "AgentActivity">;
